import log from 'salvo-lite/log'
import axios from 'axios'
import AjaxCart from '../helpers/AjaxCart'
import Vue from 'vue'
import Helpers from '../helpers/Helpers'
import pageContext from 'salvo-lite/context'
import Slick from 'vue-slick'
import AjaxAPI from '../helpers/AjaxAPI'

class CartUpsell {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._template = pageContext.getTemplate()
        this._info = ''
        this._sliderSettings = JSON.parse(this._elem.getAttribute('data-cart-upsell'))
        this._vue = null
        this._productTitle = this._elem.getAttribute('data-title')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    async onInit () {
        const information = await this._getInfo()
        this._info = await this._buildRecs(information)
        log.debug(this.constructor.name, 'Information Retrieved', this)
        this._buildUpsell()
    }
    async _getInfo () {
        const shop = window.Shopify.shop
        const cartRes = await AjaxCart.getCart()
        const cart = cartRes.data
        const position = this._template
        const customerRes = axios.get('/account?view=cartconvert.json')
        const customer = customerRes.data
        let variant = ''
        if (cart.items[0]) {
            variant = cart.items[0].id
        }
        const data = {shop, cart, customer, position, variant}
        const infoDump = await axios.post('https://api.cartconvert.eastsidecoapps.io/app/api/v1/recommendations.json', data)
        return infoDump.data
    }
    async _buildRecs (info) {
        for (var i = 0; i < info.recommendations.length; i++) {
            const prodDump = await AjaxAPI.getProduct(info.recommendations[i].handle)
            const prodData = prodDump.data
            info.recommendations[i].available = prodData.available
            info.recommendations[i].compare_at_price = prodData.compare_at_price
            info.recommendations[i].price = prodData.price
            info.recommendations[i].featured_image = prodData.featured_image
            info.recommendations[i].url = prodData.url
            info.recommendations[i].badge = ''
            info.recommendations[i].variantArray = prodData.variants
            const tags = info.recommendations[i].tags.split(',')
            for (var t = 0; t < tags.length; t++) {
                let tag = tags[t].trim()
                if (tag.includes('badge_')) {
                    info.recommendations[i].badge = tag.replace('badge_', '')
                    break
                }
            }
        }
        if (this._productTitle) {
            const existingSub = info.settings.product.translation.sub_heading
            const newSub = existingSub.replace('{{title}}', this._productTitle)
            info.settings.product.translation.sub_heading = newSub
        }
        return info
    }
    _buildUpsell () {
        this._vue = new Vue({
            el: '.cart__upsell',
            data: {
                recommendations: this._info.recommendations,
                settings: this._info.settings,
                templateName: this._template,
                sliderSettings: this._sliderSettings,
                theme: this._theme
            },
            mounted: async function () {
                this.theme.registerComponents(this.$el)
            },
            filters: {
                money: (n) => {
                    return Helpers.formatMoney(n)
                }
            },
            components: {
                'slick': Slick
            },
            methods: {
                buildProducts: async function () {
                },
                rebuild: function () {
                }
            }
        })
        window.vueJob = this._vue
    }
}
export default CartUpsell



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CartUpsell.js